"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminTreeType = void 0;
var AdminTreeType;
(function (AdminTreeType) {
    AdminTreeType["DEFAULT"] = "DEFAULT";
    AdminTreeType["EDEN_PRICE_MATCH"] = "EDEN_PRICE_MATCH";
    AdminTreeType["REFERRAL"] = "REFERRAL";
    AdminTreeType["REFERRED"] = "REFERRED";
    AdminTreeType["WITH_SIGN"] = "WITH_SIGN";
})(AdminTreeType = exports.AdminTreeType || (exports.AdminTreeType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRtaW4tcGFuZWwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdHlwZXMvYWRtaW4tcGFuZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBR0EsSUFBWSxhQU1YO0FBTkQsV0FBWSxhQUFhO0lBQ3ZCLG9DQUFtQixDQUFBO0lBQ25CLHNEQUFxQyxDQUFBO0lBQ3JDLHNDQUFxQixDQUFBO0lBQ3JCLHNDQUFxQixDQUFBO0lBQ3JCLHdDQUF1QixDQUFBO0FBQ3pCLENBQUMsRUFOVyxhQUFhLEdBQWIscUJBQWEsS0FBYixxQkFBYSxRQU14QiJ9